import toast from 'react-hot-toast';
import secureAxios from '../secure_axios';

const baseUrl = 'cpf-role'

async function servGetRolesPorCpf(cpf) {
    try {
        const response = await secureAxios.get(`${baseUrl}/get-roles-por-cpf`, {
            params: { cpf }
        })
        return response
    } catch (error) {
        throw error
    }
}

async function servAssociaCpfRole(associacao) {
    try {
        const response = await secureAxios.post(`${baseUrl}/associa-cpf-role`, associacao)
        toast.success(response.data.message)
        return response
    } catch (error) {
        throw error
    }
}

async function servDesassociaCpfRole(cpfRoleId) {
    const response = await secureAxios.delete(`${baseUrl}/desassocia-cpf-role`, {
        params: { cpfRoleId }
    })
    return response
}

export {
    servGetRolesPorCpf,
    servAssociaCpfRole,
    servDesassociaCpfRole
}